// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { upRightFromSquare16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-up-right-from-square': IconUpRightFromSquare;
    }
}

/**
 * The icon component for the 'upRightFromSquare' icon
 */
export class IconUpRightFromSquare extends Icon {
    public constructor() {
        super(upRightFromSquare16X16);
    }
}

registerIcon('icon-up-right-from-square', IconUpRightFromSquare);
export const iconUpRightFromSquareTag = 'nimble-icon-up-right-from-square';
